import { breakpoints, IconRegularClose, theme } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

// 44px – minimum accessible tap target for the close button.
const CLOSE_BUTTON_SIZE = '2.75rem';

export const CloseButton = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  width: ${CLOSE_BUTTON_SIZE};
  height: ${CLOSE_BUTTON_SIZE};
  border-radius: 50%;

  background: ${theme.color.background.primary};
  color: ${theme.color.icon.primary};

  transition: box-shadow 0.15s ease-in-out;

  /* Shown only once the modal content scrolls beneath the sticky button. */
  &.isScrolled {
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.15);
  }

  &:focus-visible {
    outline: 2px solid ${theme.color.icon.primary};
    outline-offset: 2px;
  }
`;

export const CloseIcon = styled(IconRegularClose)`
  width: 1.25rem;
  height: 1.25rem;
`;

export const ModalTitleWrapper = styled.div`
  ${theme.typography.titleLarge};
`;

export const modalHeaderWrapperClass = css`
  /* Below md the success screen lives in a drawer whose own floating close
     button is used instead of this sticky one. */
  display: none;

  @media (min-width: ${breakpoints.md}) {
    display: flex;
    justify-content: flex-end;
    position: sticky;
    top: 0;
    z-index: 2;
    margin: -1rem -1rem 0;
    padding: 1rem;
  }
`;

export const modalHeaderWrapperNewDesignClass = css`
  display: none;

  @media (min-width: ${breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 2;
    /* bleed over the form's side padding so the bar spans the modal edges */
    margin: 0 -1.5rem;
    padding: 1.5rem;
    background: ${theme.color.background.primary};
    transition: box-shadow 0.15s ease-in-out;
  }
`;

// Bottom shadow applied to the sticky form header once the content scrolls.
export const headerScrolledClass = css`
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.15);
`;
